const AUTH_TOKEN_KEY = "authToken"
const PROFILE_KEY = "profile"

export function getAuthToken(): string | null {
  try {
    return localStorage.getItem(AUTH_TOKEN_KEY)
  } catch {
    return null
  }
}

export function setAuthToken(token: string): void {
  localStorage.setItem(AUTH_TOKEN_KEY, token)
}

export function clearAuthToken(): void {
  localStorage.removeItem(AUTH_TOKEN_KEY)
}

export function getStoredProfile(): unknown | null {
  try {
    const raw = localStorage.getItem(PROFILE_KEY)
    if (!raw) return null
    return JSON.parse(raw) as unknown
  } catch {
    return null
  }
}

export function setStoredProfile(profile: unknown): void {
  localStorage.setItem(PROFILE_KEY, JSON.stringify(profile))
}

export function clearStoredProfile(): void {
  localStorage.removeItem(PROFILE_KEY)
}
